module.exports = __webpack_public_path__ + "components/outside-promo-page/static/app-60f3115288a9b6cf0986f00754ec28dc.png";